<template>
  <div class="dashboard-block">
    <div class="alert alert-info alert-icon">
      <i class="fa fa-info"></i>

      Please verify your email address.

      <template v-if="$userIsClient">
        You can not submit a booking request until your account is verified.
      </template>

      <span v-if="resendingVerificationEmail" class="fa fa-circle-o-notch fa-spin fa-fw"></span>
      <a v-else href="" @click.prevent="handleResendVerificationEmailCallback">Resend Email.</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { notify } from 'utils'

export default {
  data () {
    return {
      resendingVerificationEmail: false
    }
  },

  methods: {
    ...mapActions('user', ['resendUserVerificationEmail']),

    /**
     * Handle resending the verification email.
     *
     * @return void
     */
    handleResendVerificationEmailCallback () {
      if (this.resendingVerificationEmail) {
        return
      }

      this.resendingVerificationEmail = true

      this.resendUserVerificationEmail({ id: this.$user.id })
        .then(() => {
          this.resendingVerificationEmail = false

          notify.success(`Check your inbox! We've sent you another verification email.`)
        })
    }
  }
}
</script>
